import { render, staticRenderFns } from "./IniciacaoCientifica.vue?vue&type=template&id=05ca7717&"
import script from "./IniciacaoCientifica.vue?vue&type=script&lang=js&"
export * from "./IniciacaoCientifica.vue?vue&type=script&lang=js&"
import style0 from "./IniciacaoCientifica.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports